import { render, staticRenderFns } from "./Profesionales.vue?vue&type=template&id=3685b49c&scoped=true&"
import script from "./Profesionales.vue?vue&type=script&lang=js&"
export * from "./Profesionales.vue?vue&type=script&lang=js&"
import style0 from "./Profesionales.vue?vue&type=style&index=0&id=3685b49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3685b49c",
  null
  
)

export default component.exports